var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"stroke":"#103C96","strokeWidth":".889","fill":"#103C96","cx":"24","cy":"24","r":"24","key":0}),React.createElement("path",{"d":"M19.124 12a2.609 2.609 0 0 0-2.609 2.609v18.77a2.608 2.608 0 1 0 5.217 0v-18.77A2.608 2.608 0 0 0 19.124 12zm9.391 0a2.609 2.609 0 0 0-2.609 2.609v18.77a2.608 2.608 0 1 0 5.218 0v-18.77A2.609 2.609 0 0 0 28.515 12z","fillRule":"nonzero","fill":"#FFF","key":1})]));
}

Pause.defaultProps = {};

module.exports = Pause;

Pause.default = Pause;
